export const DESCRIPTION =
  'Looking for free discounts? Here at BeansiD we work with brands to get you the best exclusive deals.'

export const LD_DATA = [{ type: 'Organisation' }]
